export default function GridDesign() {
	return (
		<div className="absolute left-0 top-0 h-full w-full border-b border-dashed border-border">
			<div className="container relative h-full px-4 md:px-6">
				<div className="grid h-full w-full grid-cols-12">
					{[...Array(12)].map((_, i) => (
						<div
							key={i}
							className={`col-span-1 border-l-[1px] border-dashed ${
								i === 11 ? 'border-r-[1px]' : ''
							} ${
								i === 0 || i === 11 ? 'border-border' : 'border-muted dark:border-muted/60'
							} ${i === 11 ? 'border-l-muted dark:border-l-muted/60' : ''}`}
						/>
					))}
				</div>
			</div>
		</div>
	)
}
